module.exports = "/8/10-phan-loai-cac-vung-nho-stack-va-heap/index.html.f3d953ab58d5d6d7caa9a6825ab85eff.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/32101.md
 ** module id = 575
 ** module chunks = 0
 **/